import { Link } from "react-router-dom";
import { Mail, Globe2, Clock3, MapPin } from "lucide-react";

const columns = [
  {
    title: "Company",
    links: [
      { label: "About Vowpin", to: "/about" },
      { label: "Solutions", to: "/solutions" },
      { label: "Blog & Insights", to: "/blog" },
      { label: "FAQ", to: "/faq" },
      { label: "Contact", to: "/contact" },
    ],
  },
  {
    title: "Catalog",
    links: [
      { label: "Retail & Lifestyle", to: "/products" },
      { label: "Gaming", to: "/products" },
      { label: "Travel", to: "/products" },
      { label: "Food & Dining", to: "/products" },
      { label: "India Catalogue", to: "/regions/india" },
      { label: "UAE Catalogue", to: "/regions/uae" },
      { label: "KSA Catalogue", to: "/regions/ksa" },
      { label: "USA Catalogue", to: "/regions/usa" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-[#0816a8]">
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-10">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1.2fr]">
          <div>
            <Link to="/" data-testid="footer-logo" className="flex items-center">
              <img src="/logo-white.png" alt="Vowpin Global" className="h-[72px] w-auto" />
            </Link>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-[#c7cef5]">
              Global digital gift card distribution & reward solutions — connecting businesses with
              the world's leading digital brands.
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <span className="flex items-center gap-1.5 rounded-full border border-white/15 px-3 py-1.5 text-xs text-[#c7cef5]">
                <Globe2 className="h-3.5 w-3.5 text-[#f4a900]" /> 120+ countries
              </span>
              <span className="flex items-center gap-1.5 rounded-full border border-white/15 px-3 py-1.5 text-xs text-[#c7cef5]">
                <Clock3 className="h-3.5 w-3.5 text-[#f4a900]" /> 24/7 digital fulfillment
              </span>
            </div>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="text-xs font-semibold uppercase tracking-[0.25em] text-[#9fa8f0]">{col.title}</h4>
              <ul className="mt-5 space-y-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link
                      to={l.to}
                      data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                      className="text-sm text-[#c7cef5] transition-colors duration-200 hover:text-white"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-[0.25em] text-[#9fa8f0]">Talk to us</h4>
            <ul className="mt-5 space-y-4">
              <li>
                <a href="mailto:raman@vowpin.com" data-testid="footer-email-raman" className="group flex items-start gap-2.5 text-sm">
                  <Mail className="mt-0.5 h-4 w-4 text-[#f4a900]" />
                  <span>
                    <span className="block text-xs uppercase tracking-widest text-[#9fa8f0]">Sales Enquiries</span>
                    <span className="text-white/90 group-hover:text-white">raman@vowpin.com</span>
                  </span>
                </a>
              </li>
              <li>
                <a href="mailto:sam@vowpin.com" data-testid="footer-email-sam" className="group flex items-start gap-2.5 text-sm">
                  <Mail className="mt-0.5 h-4 w-4 text-[#f4a900]" />
                  <span>
                    <span className="block text-xs uppercase tracking-widest text-[#9fa8f0]">Business Partnerships</span>
                    <span className="text-white/90 group-hover:text-white">sam@vowpin.com</span>
                  </span>
                </a>
              </li>
              <li>
                <div className="flex items-start gap-2.5 text-sm" data-testid="footer-address">
                  <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#f4a900]" />
                  <span>
                    <span className="block text-xs uppercase tracking-widest text-[#9fa8f0]">Registered Office</span>
                    <span className="leading-relaxed text-white/90">
                      Building A1, Dubai Digital Park, Dubai Silicon Oasis, Dubai, United Arab Emirates
                    </span>
                  </span>
                </div>
              </li>
            </ul>
            <Link
              to="/contact"
              data-testid="footer-request-catalogue-btn"
              className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#f4a900] px-5 py-2.5 text-sm font-semibold text-[#3d2a00] transition-shadow duration-300 hover:shadow-[0_0_28px_rgba(244,169,0,0.45)]"
            >
              Request Catalogue
            </Link>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 sm:flex-row sm:items-center">
          <p className="text-xs text-white/75">© {new Date().getFullYear()} Vowpin Global. All rights reserved.</p>
          <p className="text-xs text-white/75">500+ digital brands · Serving Europe, Asia, Middle East & Africa</p>
        </div>
      </div>
    </footer>
  );
}
